import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { LeaseExpirationDto, LandTitleDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-lease-expiration',
  templateUrl: './lease-expiration.component.html',
  styleUrls: ['./lease-expiration.component.scss']
})
export class LeaseExpirationComponent implements OnChanges {

  @Input() countries: LeaseExpirationDto[];
  @Input() landtitles: LandTitleDto[];
  leaseexpirationForm: FormGroup;
  leaseexpirationFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<LeaseExpirationDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredLeaseExpiration: Array<any> = [];
  status: boolean;
  selectedLeaseExpirationId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    
    this.createLeaseExpirationForm();

  }

  createLeaseExpirationForm() {
    this.leaseexpirationFormArray = this.fb.group({ Countries: this.fb.array([]) });
    this.leaseexpirationForm = this.fb.group({
      ParcelId: ['', Validators.required],
        LandTitleId: this.selectedLeaseExpirationId,
        id: null
    });
  }


  // method to display companies
  setLeaseExpiration() {
    const control = this.leaseexpirationFormArray.controls.Countries as FormArray;
    this.filteredLeaseExpiration.forEach((e) => {
      control.push(
        this.fb.group({
          ParcelId: e.ParcelId,
          LandTitleId: e.LandTitleId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addLeaseExpiration(leaseexpiration: LeaseExpirationDto) {
    console.log('leaseexpiration');
    const control = this.leaseexpirationFormArray.controls.Countries as FormArray;
    control.insert(
      0,
      this.fb.group({
        ParcelId: leaseexpiration.ParcelId,
        LandTitleId: this.selectedLeaseExpirationId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.leaseexpirationFormArray.controls.Countries as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter leaseexpiration
  selectLandTitle(event: string) {
    this.filteredLeaseExpiration = this.countries.filter((s) => s.LandTitleId === event);
    this.selectedLeaseExpirationId = event;
    const control = this.leaseexpirationFormArray.controls.Countries as FormArray;

    if (this.filteredLeaseExpiration.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setLeaseExpiration();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteLeaseExpiration(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.leaseexpirationFormArray.controls.Countries as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.countries.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.countries[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: LeaseExpirationDto) {
    if(this.leaseexpirationForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.leaseexpirationFormArray.get('Countries')['controls'][this.selectedIndex].patchValue({ParcelId: formValue.ParcelId});
    } else {
      this.addLeaseExpiration(formValue);
    }
    this.selectedIndex = null;
    this.leaseexpirationForm.reset()
  }

  onEdit(index, value: LeaseExpirationDto) {
    this.selectedIndex = index;
    this.leaseexpirationForm.patchValue({ParcelId: value.ParcelId});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.leaseexpirationForm.reset();
  }


  onSubmit(formValue: any) {
    formValue.type = 'leaseexpiration';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('leaseexpiration');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
